<template>
  <div>
    <v-text-field
      ref="inputRef"
      class="rounded-0"
      v-model="number"
      pattern="[0-9]*"
      :rules="[
        v => !!v || 'Fødselsnummer må fylles ut!',
        telRequired,
        telLength,
        telNotMoreThanEight
      ]"
      :label="label"
      :prepend-inner-icon="prependInnerIcon"
      :counter="11"
      :counter-value="counterValue"
      placeholder="xxxxxx-xxxxx"
      :outlined="outlined"
      :filled="filled"
      :dense="dense"
      :disabled="disabled"
      @change="telFinishedChange = true"
      @blur="fucusInput = false"
      @focus="fucusInput = true"
      :autocomplete="autocomplete"
      required
    ></v-text-field>
  </div>
</template>

<script>
import format from "@/helpers/format";
export default {
  props: {
    value: {
      default: null
    },
    label: {
      type: String,
      default: "Fødselsnummer"
    },
    outlined: {
      type: Boolean,
      default: false
    },
    filled: {
      type: Boolean,
      default: false
    },
    dense: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    prependInnerIcon: {
      type: String,
      default: null
    },
    autocomplete: {
      type: String,
      default: "off"
    }
  },
  data() {
    return {
      telFinishedChange: false,
      fucusInput: false
    };
  },
  methods: {
    convertToNumber(value) {
      this.number = value;
    }
  },
  computed: {
    number: {
      get: function() {
        if (!this.fucusInput) {
          var num = format.personNumber(this.value);

          return num;
        }

        return this.value;
      },
      set: function(value) {
        var value = value.replace("-", "")
          ? value.replace("-", "").replace(/\s/g, "")
          : null;

        this.$emit(
          "input",
          !isNaN(value) ? value : this.$refs.inputRef.reset()
        );
      }
    },
    counterValue() {
      return v => {
        return !!v && v.toString().replace("-", "").length
          ? v.toString().replace("-", "").length
          : 0;
      };
    },
    telRequired() {
      return () => !isNaN(this.value) || "Fødselsnummer må være et nummer!";
    },
    telLength() {
      if (this.telFinishedChange) {
        return value =>
          (value && value.toString().replace("-", "").length >= 11) ||
          "Fødselsnummer må være 11 siffer!";
      }
      return true;
    },
    telNotMoreThanEight() {
      return value => {
        return (
          (!!value && value.toString().replace("-", "").length <= 11) ||
          "Fødselsnummer må være 11 siffer!"
        );
      };
    }
  }
};
</script>
